import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  // Unique images not used on other pages
  const images = {
    hero: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/7e4ktww2_Honey_0172-Edit.jpg',
    lifestyle1: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/iwnkk13u_Honey%20Sofia%20-%201108-Edit-skin%20smoothing.jpg',
    lifestyle2: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/z730fvdr_Honey%20Sofia%20-%201644-Edit-face%20blur.jpg',
    intimate: 'https://customer-assets.emergentagent.com/job_intimate-editorial/artifacts/eiop63nc_Honey%20Sofia%20-%201653-Edit-face%20blur.jpg'
  };

  return (
    <div>
      {/* Hero Section with Image and Intro */}
      <section style={{ 
        padding: '80px 40px 60px', 
        background: 'var(--bg-primary)' 
      }}>
        <div className="container">
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: '1fr',
            gap: '60px',
            maxWidth: '1200px',
            margin: '0 auto'
          }}
          className="about-hero-grid"
          >
            {/* Hero Image */}
            <div style={{ maxWidth: '600px', margin: '0 auto' }}>
              <img 
                src={images.hero} 
                alt="Honey Sofia"
                style={{ 
                  width: '100%', 
                  height: 'auto',
                  display: 'block'
                }}
              />
            </div>
            
            {/* Opening Statement */}
            <div style={{ maxWidth: '700px', margin: '0 auto', textAlign: 'center' }}>
              <h1 className="hero-large" style={{ marginBottom: '32px', lineHeight: '1.3' }}>
                More than a moment.<br />An experience you'll remember.
              </h1>
              <p className="body-large" style={{ 
                lineHeight: '1.9', 
                color: 'var(--text-primary)',
                fontSize: '20px'
              }}>
                I'm not for everyone. And that's intentional. I'm warm, intuitive, and unapologetically selective about who I spend time with. If you're reading this, chances are you already know whether we're a match.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* About Content */}
      <section className="section-padding-small">
        <div className="container">
          <div style={{ maxWidth: '900px', margin: '0 auto' }}>
            
            {/* Physical Description with Image */}
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: '1fr',
              gap: '48px',
              marginBottom: '80px',
              alignItems: 'center'
            }}
            className="about-section-grid"
            >
              <div>
                <h2 className="heading-1" style={{ marginBottom: '24px', color: 'var(--burgundy)' }}>
                  First Impressions
                </h2>
                <p className="body-large" style={{ lineHeight: '1.9', color: 'var(--text-primary)', marginBottom: '20px' }}>
                  160cm of Mediterranean warmth with a Kiwi edge. Australian size 4-6, brunette, hazel eyes that shift with the light and my mood. A few small tattoos, delicate piercings — just enough to suggest there's more beneath the surface.
                </p>
                <p className="body-large" style={{ lineHeight: '1.9', color: 'var(--text-primary)', marginBottom: '20px' }}>
                  Toned but soft in all the right places. My body tells the story of someone who takes care of herself but isn't obsessed with perfection. Natural. Real. Exactly what you've been craving.
                </p>
                <p className="body-large" style={{ 
                  lineHeight: '1.9', 
                  color: 'var(--burgundy)',
                  fontStyle: 'italic',
                  padding: '24px 0 24px 24px',
                  borderLeft: '3px solid var(--burgundy)'
                }}>
                  "That effortless confidence you can't fake — the kind that makes you feel like you're the only person in the room."
                </p>
              </div>
              
              <div>
                <img 
                  src={images.lifestyle1} 
                  alt="Honey Sofia"
                  style={{ 
                    width: '100%', 
                    height: 'auto',
                    display: 'block'
                  }}
                />
              </div>
            </div>

            {/* What Makes Me Different - Reverse Layout */}
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: '1fr',
              gap: '48px',
              marginBottom: '80px',
              alignItems: 'center'
            }}
            className="about-section-grid-reverse"
            >
              <div style={{ order: 2 }} className="about-text-order">
                <h2 className="heading-1" style={{ marginBottom: '24px', color: 'var(--burgundy)' }}>
                  What Makes Me Different
                </h2>
                <p className="body-large" style={{ lineHeight: '1.9', color: 'var(--text-primary)', marginBottom: '20px' }}>
                  I don't rush. I don't perform. I don't pretend to be someone I'm not to make you comfortable. Instead, I read people — their energy, their needs, what they're not saying out loud — and I adjust accordingly.
                </p>
                <p className="body-large" style={{ lineHeight: '1.9', color: 'var(--text-primary)', marginBottom: '20px' }}>
                  Some men need conversation. Others need quiet. Some want to be challenged intellectually before they can fully let go physically. I make all of it feel natural, never forced.
                </p>
                <p className="body-large" style={{ lineHeight: '1.9', color: 'var(--text-primary)', marginBottom: '20px' }}>
                  There's a calm confidence to me that puts people at ease almost immediately. You won't feel like you're "booking time." It feels like you're stepping into something you've been missing — something real, indulgent, and exactly what you needed without having to explain it.
                </p>
                <p className="body-large" style={{ lineHeight: '1.9', color: 'var(--text-primary)' }}>
                  I'm selective with who I see, which means the experience stays consistently excellent. No chaos. No awkwardness. No wondering if it'll be worth it. Just chemistry, presence, and hours that slip away faster than you'd like.
                </p>
              </div>
              
              <div style={{ order: 1 }} className="about-image-order">
                <img 
                  src={images.lifestyle2} 
                  alt="Honey Sofia"
                  style={{ 
                    width: '100%', 
                    height: 'auto',
                    display: 'block'
                  }}
                />
              </div>
            </div>

            {/* Lifestyle & Interests */}
            <div style={{ 
              background: 'rgba(90, 30, 43, 0.03)', 
              padding: '60px 48px',
              marginBottom: '80px',
              borderRadius: '2px'
            }}
            className="about-lifestyle-box"
            >
              <h2 className="heading-1" style={{ marginBottom: '24px', textAlign: 'center', color: 'var(--burgundy)' }}>
                Beyond the Bedroom
              </h2>
              <p className="body-large" style={{ 
                lineHeight: '1.9', 
                color: 'var(--text-primary)', 
                marginBottom: '24px',
                textAlign: 'center',
                maxWidth: '700px',
                margin: '0 auto 32px'
              }}>
                I'm not one-dimensional. If you're looking for someone who can hold a conversation as well as they hold your attention, you're in the right place.
              </p>
              
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: '1fr 1fr',
                gap: '32px',
                marginTop: '32px'
              }}
              className="about-interests-grid"
              >
                <div>
                  <h3 className="heading-3" style={{ marginBottom: '16px', color: 'var(--burgundy)' }}>
                    What I Love
                  </h3>
                  <p className="body-regular" style={{ lineHeight: '1.8', color: 'var(--text-secondary)', textAlign: 'left' }}>
                    Long dinners that turn into longer conversations. Museums, galleries, places with history. Getting outdoors — ocean swims, long walks, fresh air. Travel, good wine, and discovering restaurants worth remembering.
                  </p>
                </div>
                
                <div>
                  <h3 className="heading-3" style={{ marginBottom: '16px', color: 'var(--burgundy)' }}>
                    What I Value
                  </h3>
                  <p className="body-regular" style={{ lineHeight: '1.8', color: 'var(--text-secondary)', textAlign: 'left' }}>
                    Depth over surface-level small talk. Presence over performance. People who appreciate quality, discretion, and the art of taking your time. If you get it, you get it.
                  </p>
                </div>
              </div>
            </div>

            {/* Background & Philosophy */}
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: '1fr',
              gap: '48px',
              marginBottom: '80px',
              alignItems: 'center'
            }}
            className="about-section-grid"
            >
              <div>
                <h2 className="heading-1" style={{ marginBottom: '24px', color: 'var(--burgundy)' }}>
                  How I Work
                </h2>
                <p className="body-large" style={{ lineHeight: '1.9', color: 'var(--text-primary)', marginBottom: '20px' }}>
                  Sydney-based, independent, and refreshingly uncomplicated. I've built my own business outside of this world, which means I understand time, discretion, and the value of doing things properly.
                </p>
                <p className="body-large" style={{ lineHeight: '1.9', color: 'var(--text-primary)', marginBottom: '20px' }}>
                  I'm not juggling a dozen bookings a day or squeezing you in between appointments. I'm selective, which means when we're together, you have my full attention. No distractions. No rushing. Just two people enjoying something that feels like it was always meant to happen.
                </p>
                <p className="body-large" style={{ lineHeight: '1.9', color: 'var(--text-primary)' }}>
                  I'm organised, self-aware, and genuinely easy to be around. You won't need to manage my mood or walk on eggshells. I make this effortless because it should be.
                </p>
              </div>
              
              <div>
                <img 
                  src={images.intimate} 
                  alt="Honey Sofia"
                  style={{ 
                    width: '100%', 
                    height: 'auto',
                    display: 'block'
                  }}
                />
              </div>
            </div>

            {/* Final CTA */}
            <div style={{ 
              marginTop: '80px', 
              padding: '60px 48px',
              textAlign: 'center',
              background: 'linear-gradient(to bottom, rgba(90, 30, 43, 0.05), rgba(90, 30, 43, 0.02))',
              borderTop: '1px solid var(--border-light)',
              borderBottom: '1px solid var(--border-light)'
            }}
            className="about-cta-box"
            >
              <h2 className="hero-medium" style={{ marginBottom: '24px', color: 'var(--burgundy)' }}>
                Still reading?
              </h2>
              <p className="body-large" style={{ 
                marginBottom: '40px', 
                maxWidth: '600px',
                margin: '0 auto 40px',
                lineHeight: '1.9',
                color: 'var(--text-primary)'
              }}>
                That's a good sign. It means you're not rushing. You're paying attention. You're looking for something real, not just transactional. 
              </p>
              <p className="body-large" style={{ 
                marginBottom: '40px',
                fontStyle: 'italic',
                color: 'var(--burgundy)',
                fontSize: '22px'
              }}>
                We're probably a perfect match.
              </p>
              <Link to="/bookings" className="btn-primary" style={{ fontSize: '18px', padding: '16px 48px' }}>
                Let's Talk
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
